import { MetadataFieldMappingList } from '@modules/integrationsV2/components/LinkIntegrationMetadataSection/MetadataFieldMappingList';
import { NoIntegrationsFoundForType } from '@modules/integrationsV2/components/LinkIntegrationMetadataSection/NoIntegrationsFoundForType';
import { IntegrationSource } from '@modules/integrationsV2/types';
import {
  getDisplayNameForIntegrationType,
  getIconForIntegrationType,
  getIntegrationSourcesGroupedByType,
} from '@modules/integrationsV2/utils';
import { Box, Stack, Typography } from '@mui/material';
import { IntegrationType, IntegrationViewFragment } from 'generated/graphql';

interface LinkIntegrationMetadataForTypeProps {
  integrationType: IntegrationType;
  integrationSource: IntegrationSource;
  integrations: IntegrationViewFragment[];
}

export const LinkIntegrationMetadataForType = ({
  integrationType,
  integrationSource,
  integrations,
}: LinkIntegrationMetadataForTypeProps) => {
  const integrationSourcesGroupedByType =
    getIntegrationSourcesGroupedByType(integrations);

  const targetIntegrationSources =
    integrationSourcesGroupedByType[integrationType];

  const renderIntegrationTypeTitle = () => {
    return (
      <Stack direction="row" alignItems="center" spacing={1}>
        {getIconForIntegrationType({
          integrationType,
        })}
        <Typography>
          Link {getDisplayNameForIntegrationType(integrationType)} Integration
        </Typography>
      </Stack>
    );
  };

  if (!targetIntegrationSources?.length) {
    return (
      <Stack spacing={3} py={3}>
        {renderIntegrationTypeTitle()}
        <Box pl={4.1}>
          <NoIntegrationsFoundForType integrationType={integrationType} />
        </Box>
      </Stack>
    );
  }

  return (
    <Stack py={3} spacing={3}>
      <Stack direction="row" alignItems="center" spacing={3}>
        {renderIntegrationTypeTitle()}
        <Typography variant="caption" color="text.secondary">
          Select the {integrationSource.channel.displayName} metadata field to
          link with {getDisplayNameForIntegrationType(integrationType)}{' '}
          integrations
        </Typography>
      </Stack>
      <Box pl={4.1}>
        <MetadataFieldMappingList
          sourceIntegrationSource={integrationSource}
          targetIntegrationSources={targetIntegrationSources}
        />
      </Box>
    </Stack>
  );
};
